<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'

defineProps<{
  disabled?: boolean
  noicon?: boolean
  grey?: boolean
  border?: boolean
  active?: boolean

  to: RouteLocationRaw | undefined
  txt: stringI18n | undefined
}>()
const init3 = useInited('init3')
</script>

<template>
  <NuxtLink :to="disabled ? undefined : to" :disabled :class="[$style.btn, !disabled && $style.animate, { on: active, disabled }, 'IconArrow', active && ['on', 'IconArrowOn'], border && '_wmax']">
    <span :class="[$style.wrap2, grey && $style.grey, border && '_b1']">
      <span :class="[$style.txt11, border && '_fw-xl']">
        <span v-if="!noicon" class="_ctr _mr14 _svg24"
          ><slot v-if="init3"><LazyIconArrow :class="$style.arr" :stroke="1.8" /></slot
        ></span>
        <slot name="txt">{{ txt }}</slot>
        <slot name="after" />
      </span>
      <span v-if="init3 || active" :class="$style.txt22">
        <span v-if="!noicon" class="_ctr _mr14 _svg24"
          ><slot v-if="init3"><LazyIconArrow :class="$style.arr" :stroke="1.8" /></slot
        ></span>
        <slot name="txt">{{ txt }}</slot>
        <slot name="after" />
      </span>
    </span>
  </NuxtLink>
</template>

<style module>
.arr {
  composes: global(_svg24);
  color: var(--black);
}

.btn {
  composes: global(_row);
  composes: global(_fw-l);
  composes: global(_fs09);
  composes: global(_ls-xs);
  composes: global(_relative);
  composes: global(d_h40);
  composes: global(m_h44);
  cursor: pointer;
}

.btn:global(.disabled) {
  cursor: default;
}
.btn:global(.disabled) .wrap2 {
  background: var(--black-6);
  color: var(--black-4);
}

.grey {
  composes: global(_fw-xl);
  composes: global(_ls-xs);

  composes: global(_c1);

  composes: global(_bg5);
  --background: var(--blue3);
}

.wrap2 {
  composes: global(_relative);
  composes: global(_wcont);

  composes: global(_pt04);
  composes: global(_pr2);
  composes: global(_pb04);
  composes: global(_pl1);

  composes: global(_row);
  composes: global(_inline);
  composes: global(_ctrY);
  composes: global(_hidden);

  composes: global(_br22);
  composes: global(m_flex);

  composes: global(_start);
  z-index: 1;
  /* :global(.m) .wrap2 {
    width: auto;
    flex-grow: 1;
  } */
}

.wrap {
  composes: global(_relative);
  composes: global(_row);
  composes: global(_w100p);
  composes: global(_noselect);
  z-index: 1;
}

.txt11,
.txt22 {
  composes: global(_h100p);
  composes: global(_w100p);
  composes: global(_row);
  composes: global(_ctrY);

  composes: global(_pt04);
  composes: global(_pr02);
  composes: global(_pb04);

  transition:
    transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
    opacity 200ms cubic-bezier(0.23, 1, 0.32, 1);
}

.txt11 {
  transition-delay: 100ms;
}
.txt22 {
  composes: global(_absolute);
  top: 0;
  left: 0;
  right: -2px;
  composes: global(_h100p);
  composes: global(_row);
  composes: global(_ctrY);
  composes: global(_fw-xl);
  composes: global(_ls-xs);
  composes: global(_pt04);
  composes: global(_pb04);
  composes: global(_pl1);

  composes: global(_start);
  composes: global(_c0);

  transform: translate3d(0, 100%, 0) rotateX(45deg);
  transform-origin: 50% 100%;
}
.animate:global(.on) .txt11,
.animate:hover .txt11 {
  opacity: 0;
  transform: translate3d(0, -100%, 0);
  transition-delay: 0s;
}

.animate:global(.on) .txt22,
.animate:hover .txt22 {
  transform: translateZ(0);
  transition-delay: 0.08s;
}

.animate .wrap2::before {
  content: '';
  position: absolute;
  top: -1px;
  left: -1px;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  border-radius: 99px;
  background-color: var(--background, var(--black));
  clip-path: inset(calc(100% - 7px) 7px 7px 7px round 99px);
  transition:
    clip-path 0.45s cubic-bezier(0.23, 1, 0.32, 1),
    -webkit-clip-path 0.45s cubic-bezier(0.23, 1, 0.32, 1);
}

.animate:hover .wrap2::before,
.animate:global(.on) .wrap2::before {
  clip-path: inset(0 0 0 0 round 99px);
}

.animate:global(.on) .chev,
.animate:hover .chev,
.animate:global(.on) .txt22 svg,
.animate:hover .txt22 svg {
  color: var(--bg);
}
</style>
